import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Typography,
  Grid,
  Fab
} from '@mui/material';
import AnimatedLayout from '../layout/AnimatedLayout/AnimatedLayout';
import './CustomError.css';
import { setErrorFalse } from '../ErrorHandler/errorHandlerSlice';
import API from '../../api/Api';
import { useAppDispatch } from '../../shared/redux/store';

interface CustomErrorProps {
  header: React.ReactNode
  title: string
  message: string
  buttonText: string
  open: boolean
  img: string
}
const CustomError:React.FC<CustomErrorProps> = ({ header, title, message, buttonText, open, img }) => {
  const dispatch = useAppDispatch();

  const handleClick = () => {
    if (header === 'Error 404') {
      history.back();
    }

    if (header === 'Error 403') {
      API.goToLogin();
    }

    if (header === 'No connection' || header === 'Error 500') {
      window.location.reload();
    }

    dispatch(setErrorFalse());
  };

  return (
    <AnimatedLayout>
      <Dialog
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              maxWidth: '40%',
              background: '#FBFBFB'
            }
          }
        }}
        open={open}
        className={'CustomDialog CustomDialog__Container CustomDialog--error'}
      >
        <Grid
          container
          direction="row"
          alignItems="stretch"
          justifyContent="center"
          spacing={0}
          className="ErrorDialog"
        >
          <Grid key={0} item xs={6}>
            <DialogTitle className="CustomError__Header">
              <Typography variant="overline">{header}</Typography>
            </DialogTitle>
            <DialogTitle className="CustomError__Title">
              <Typography>{title}</Typography>
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                component={'div'}
                className="CustomError__Content__Text"
              >
                {message}
              </DialogContentText>
            </DialogContent>
          </Grid>
          <Grid key={1} item xs={6}>
            <DialogContent>
              <img className="Gif" src={img} alt={title} />
            </DialogContent>
          </Grid>
        </Grid>

        <div className="ActionButton">
          {
            <Fab variant="extended" color="primary" onClick={handleClick}>
              {buttonText}
            </Fab>
          }
        </div>
      </Dialog>
    </AnimatedLayout>
  );
};

export default CustomError;
